import * as Yup from "yup";

export const revisionDocumentSchema = Yup.object().shape({
  name: Yup.string().required("작업명을 입력하세요"), // 작업명
  departmentUID: Yup.number(), // 부서 UID
  serialNo: Yup.number().required("일련번호를 입력하세요"), // Part No - 일련번호
  // serialNo: Yup.number().when((serialNo, schema) =>
  //   serialNo === 0 ? schema.required("일련번호를 입력하세요") : schema
  // ), // Part No - 일련번호
  firstDate: Yup.date(), // 최초 평가일
  lastDate: Yup.date(), // 최근 개정일
  revisionNo: Yup.number().required("개정번호를 입력하세요"), // 개정 번호
  extra: Yup.string(), // 비고

  // NOT DB
  base64: Yup.string(),
  addtional1Base64: Yup.string(),
  addtional2Base64: Yup.string(),

  // note not used
  // uid: Yup.number(),
  // guid: Yup.string(),
  // companyUID: Yup.number(),
  // writerUID: Yup.number(), // 작성자 UID
  // type: Yup.number(), // 0 - 작업성평가 , 1- 가동전점검
  // fileName: Yup.string(), // 파일명
  // extension: Yup.string(), // 확장자
  // additionalFile1: Yup.string(), // 추가 파일명 1
  // additionalFile2: Yup.string(), // 추가 파일명 2
  // isDeleted: Yup.boolean(),
  // entryDate: Yup.date(),
});
